import CssBaseline from "@mui/material/CssBaseline";
import AdminSidebar from "components/admin/AdminSidebar";
import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import apis from "services";
import { DataGrid } from "@mui/x-data-grid";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import NotificationTable from "components/datagrid/NotificationTable";
import ImagePreview from "../../components/modals/ImagePreview";

const NotificationsHistory = () => {
  const [notifications, setNotifications] = useState([]);
  const { t } = useTranslation();

  const [image, setImage] = useState("");
  const [imageModal, setImageModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const closeImageModal = (image) => {
    if (image) setImage(image);
    setImageModal((prevState) => !prevState);
  };

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const { data } = await apis.getAdminNotification();
      if (data?.status) {
        setNotifications(data?.notifications);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await fetchNotifications();
    })();
  }, []);

  const { rows, columns } = NotificationTable(notifications, closeImageModal);

  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            {loading ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container
                maxWidth="lg"
                sx={{ mt: 4, mb: 4 }}
                className="mainContainerComp"
              >
                {/* <h3 className="dashboard-title">{t("buttons.notifications_history")}</h3> */}
                <Grid
                  item
                  container
                  className="mt-4"
                  justifyContent="flex-end"
                  sx={{ height: "600px", position: "relative", zIndex: "10" }}
                >
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                  />
                  <img
                    src="/assets/images/frameCardBG.png"
                    alt="frameCardBG"
                    style={{
                      position: "absolute",
                      bottom: "-46px",
                      left: "-24px",
                      width: "296px",
                      // zIndex:"-1"
                    }}
                  />
                </Grid>
              </Container>
            )}
          </Box>
        </div>
      </Box>
      <ImagePreview status={imageModal} close={closeImageModal} image={image} />
    </>
  );
};

export default NotificationsHistory;
